export default {
  W9: {
    title: 'W-9 *',
    update: 'Update W-9',
    add: 'Add W-9',
  },
  W9LLC: {
    title: 'W-9 *',
    update: 'Update W-9',
    add: 'Add W-9',
  },
  LOI: {
    title: 'Indemnification Agreement *',
    update: 'View & acknowledge agreement',
    add: 'View & acknowledge agreement',
  },
  LOILLC: {
    title: 'Indemnification Agreement *',
    update: 'View & acknowledge agreement',
    add: 'View & acknowledge agreement',
  },
  LOICAN: {
    title: 'Indemnification Agreement *',
    update: 'View & acknowledge agreement',
    add: 'View & acknowledge agreement',
  },
};
